import { render, staticRenderFns } from "./pri-simulation.vue?vue&type=template&id=32d1dbbe&scoped=true"
import script from "./pri-simulation.vue?vue&type=script&lang=js"
export * from "./pri-simulation.vue?vue&type=script&lang=js"
import style0 from "./pri-simulation.vue?vue&type=style&index=0&id=32d1dbbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d1dbbe",
  null
  
)

export default component.exports